module.exports = __webpack_public_path__ + "img/horn.f29058bd.png";